import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * PDF Editor Module Service Stores
 * Updated to match backend api-types
 */
export const pdfEditorStores: ServiceStoreConfig[] = [
  {
    name: "pdf-annotations",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.pdfAnnotationsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalAnnotations = entities.length;
          const uniqueDocuments = new Set(
            entities.map((annotation: Record<string, unknown>) => annotation.documentId)
          ).size;
          const uniqueAuthors = new Set(
            entities.map((annotation: Record<string, unknown>) => annotation.createdBy)
          ).size;
          const thisWeek = entities.filter((annotation: Record<string, unknown>) => {
            const createdDate = new Date(annotation.createdAt as string);
            const now = new Date();
            const weekAgo = new Date();
            weekAgo.setDate(now.getDate() - 7);
            return createdDate > weekAgo;
          }).length;

          return [
            {
              title: "Total Annotations",
              value: () => totalAnnotations.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Unique Documents",
              value: () => uniqueDocuments.toString(),
              valueColor: "info.main",
            },
            {
              title: "Contributors",
              value: () => uniqueAuthors.toString(),
              valueColor: "success.main",
            },
            {
              title: "This Week",
              value: () => thisWeek.toString(),
              valueColor: "warning.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "pdf-documents",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.pdfDocumentsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalDocuments = entities.length;
          const shared = entities.filter(
            (doc: Record<string, unknown>) => doc.isShared === true
          ).length;
          const uniqueOwners = new Set(
            entities.map((doc: Record<string, unknown>) => doc.ownerId)
          ).size;
          const thisMonth = entities.filter((doc: Record<string, unknown>) => {
            const uploadDate = new Date(doc.uploadedAt as string);
            const now = new Date();
            return (
              uploadDate.getMonth() === now.getMonth() &&
              uploadDate.getFullYear() === now.getFullYear()
            );
          }).length;

          return [
            {
              title: "Total Documents",
              value: () => totalDocuments.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Shared",
              value: () => shared.toString(),
              valueColor: "success.main",
            },
            {
              title: "Owners",
              value: () => uniqueOwners.toString(),
              valueColor: "info.main",
            },
            {
              title: "This Month",
              value: () => thisMonth.toString(),
              valueColor: "warning.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "pdf-document-shares",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.pdfDocumentSharesStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalShares = entities.length;
          const active = entities.filter(
            (share: Record<string, unknown>) => share.status === "active"
          ).length;
          const expired = entities.filter(
            (share: Record<string, unknown>) => share.status === "expired"
          ).length;
          const uniqueDocuments = new Set(
            entities.map((share: Record<string, unknown>) => share.documentId)
          ).size;

          return [
            {
              title: "Total Shares",
              value: () => totalShares.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => active.toString(),
              valueColor: "success.main",
            },
            {
              title: "Expired",
              value: () => expired.toString(),
              valueColor: "error.main",
            },
            {
              title: "Shared Documents",
              value: () => uniqueDocuments.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
];
